const EDGE_TOLERANCE_PX = 2;

/** Which edge of a sideways-scrolling row has more content: 'start', 'end', 'both', or '' when it all fits. */
const resolveScrollOverflow = ({ scrollLeft = 0, clientWidth = 0, scrollWidth = 0 }) => {
  if (scrollWidth - clientWidth <= EDGE_TOLERANCE_PX) {
    return '';
  }
  const hasStart = scrollLeft > EDGE_TOLERANCE_PX;
  const hasEnd = scrollLeft + clientWidth < scrollWidth - EDGE_TOLERANCE_PX;
  if (hasStart && hasEnd) {
    return 'both';
  }
  return hasStart ? 'start' : 'end';
};

export default resolveScrollOverflow;
